import { useNavigate, useRouter } from '@tanstack/react-router';

export function useNavigation() {
  const navigate = useNavigate();
  const router = useRouter();

  const goToHome = () => {
    navigate({ to: '/' });
  };

  const goBack = () => {
    router.history.back();
  };

  const goForward = () => {
    router.history.forward();
  };

  const replace = (to: string, params?: Record<string, string>) => {
    navigate({ to, params, replace: true });
  };

  const push = (to: string, params?: Record<string, string>) => {
    navigate({ to, params });
  };

  return {
    goToHome,
    goBack,
    goForward,
    replace,
    push,
    navigate,
    router,
  };
}
